<template>
  <v-toolbar v-if="show">
    <v-toolbar-side-icon v-if="showGoBackButton" class="toolbar-go-back">
      <v-icon @click="goBack">arrow_back</v-icon>
    </v-toolbar-side-icon>
    <v-toolbar-title class="centered-text">Ponce<v-icon v-if="!isOnline" color="#F93A2F" class="toolbar-offline-icon">cloud_off</v-icon></v-toolbar-title>
    <v-toolbar-items v-if="showSignUpSteps" class="flex-none"><b class="align-self-center">Paso {{currentStep}} de 2</b></v-toolbar-items>
    <v-toolbar-items v-if="showOrganizationSteps" class="flex-none"><b class="align-self-center">Paso 1 de 1</b></v-toolbar-items>
  </v-toolbar>
</template>


<script>
import { EventBus } from '../../lib/event-bus.js';
export default {
  data () {
    return {
      show: this.setShow()
    };
  },
  computed: {
    currentStep () {
      return this.$store.getters.step;
    },
    showSignUpSteps () {
      return this.$store.getters.showStepSignup;
    },
    showOrganizationSteps () {
      return this.$store.getters.showStepOrganization;
    },
    isOnline () {
      return this.$store.getters.isOnline;
    },
    showGoBackButton () {
      return !['/dashboard', '/equipments'].includes(this.$route.path);
    }
  },
  methods: {
    goBack () {
      EventBus.$emit('go-back');
      this.$router.back();
    },
    setShow () {
      return this.$router.currentRoute.name !== 'Home';
    }
  },
  watch: {
    '$route' (to, from) {
      to = to.fullPath;
      this.show = true;
      if (['/'].includes(to)) {
        this.show = false;
      }
      if (!['/signUp', '/signUp2'].includes(to)) {
        this.$store.commit('setShowStepSignup', false);
      }
      if (!['/newOrganization'].includes(to)) {
        this.$store.commit('setShowStepOrganization', false);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// Toolbar.vue?4e89a40c